// ==== RING SERIES ====
// Split from the original single tempdashboard.js (originally lines 6681-7560).
// Loaded as a plain classic <script defer> alongside the other tempdashboard-*.js files --
// they all share one global scope (like separate parts of one big file), so functions and
// top-level let/const declared in any of these files are visible to all the others, as long
// as the <script> tags stay in the same order every one of these files was split in.

  // ---- RING SERIES: register the batch of ring numbers issued for a
  // year, then pick an unused one from the Add/Edit Pigeon modal instead
  // of typing it by hand. Generated ring format: CLUBCODE-YEAR-NNNN.
  let ringSeriesList = {}; // id -> data

  function listenForRingSeries() {
    const query = isAdmin ? db.collection('ringSeries') : db.collection('ringSeries').where('ownerUid', '==', auth.currentUser.uid);
    query.onSnapshot(snapshot => {
      ringSeriesList = {};
      snapshot.forEach(doc => { ringSeriesList[doc.id] = doc.data(); });
      renderRingSeriesList();
      populateRingSeriesPicker();
    }, error => {
      console.error('Ring series listener error:', error);
      showToast('⚠️ Could not load ring series: ' + error.message);
    });
  }

  function isRingInSeries(ringNumber, rs) {
    if (!ringNumber) return false;
    const prefix = `${rs.clubCode}-${rs.year}-`;
    if (!ringNumber.startsWith(prefix)) return false;
    const num = parseInt(ringNumber.slice(prefix.length), 10);
    return !isNaN(num) && num >= rs.startNum && num <= rs.endNum;
  }

  function nextAvailableRingInSeries(rs) {
    const myPigeons = allPigeonDocs.filter(d => d.p.orgId === currentOrg.slug);
    const usedNums = new Set(
      myPigeons.filter(d => isRingInSeries(d.p.ringNumber, rs))
        .map(d => parseInt(d.p.ringNumber.slice((`${rs.clubCode}-${rs.year}-`).length), 10))
    );
    for (let n = rs.startNum; n <= rs.endNum; n++) {
      if (!usedNums.has(n)) return `${rs.clubCode}-${rs.year}-${String(n).padStart(4, '0')}`;
    }
    return null; // series exhausted
  }

  // Populates the "Pick from a Ring Series" dropdown inside the Add/Edit
  // Pigeon modal -- shows how many are left so an exhausted series is
  // obvious before picking it.
  function populateRingSeriesPicker() {
    const el = document.getElementById('db-pigeon-ring-series-pick');
    if (!el) return;
    const ids = Object.keys(ringSeriesList).sort((a, b) => (ringSeriesList[b].year || 0) - (ringSeriesList[a].year || 0));
    el.innerHTML = '<option value="">Pick from a Ring Series instead...</option>' +
      ids.map(id => {
        const rs = ringSeriesList[id];
        const total = rs.endNum - rs.startNum + 1;
        const myPigeons = allPigeonDocs.filter(d => d.p.orgId === currentOrg.slug);
        const usedCount = myPigeons.filter(d => isRingInSeries(d.p.ringNumber, rs)).length;
        const left = total - usedCount;
        return `<option value="${id}" ${left <= 0 ? 'disabled' : ''}>${rs.label || (rs.clubCode + '-' + rs.year)} (${left} left)</option>`;
      }).join('');
  }
  const ringSeriesPickEl = document.getElementById('db-pigeon-ring-series-pick');
  if (ringSeriesPickEl) ringSeriesPickEl.onchange = (e) => {
    const id = e.target.value;
    if (!id) return;
    const rs = ringSeriesList[id];
    const next = rs ? nextAvailableRingInSeries(rs) : null;
    if (next) {
      document.getElementById('db-pigeon-ring').value = next;
      showToast('✅ Filled in ' + next);
    } else {
      showToast('⚠️ That series has no numbers left');
    }
    e.target.value = '';
  };

  function updateRingSeriesPreview() {
    const clubCode = document.getElementById('rs-clubcode').value.trim();
    const year = document.getElementById('rs-year').value.trim();
    const start = parseInt(document.getElementById('rs-start').value, 10);
    const end = parseInt(document.getElementById('rs-end').value, 10);
    const previewEl = document.getElementById('rs-preview');
    if (!clubCode || !year || !start || !end || end < start) {
      previewEl.textContent = 'Enter details above to see a preview.';
      return;
    }
    const first = `${clubCode}-${year}-${String(start).padStart(4, '0')}`;
    const last = `${clubCode}-${year}-${String(end).padStart(4, '0')}`;
    previewEl.textContent = `${first} to ${last} (${end - start + 1} rings)`;
  }
  ['rs-clubcode', 'rs-year', 'rs-start', 'rs-end'].forEach(id => {
    const el = document.getElementById(id);
    if (el) el.oninput = updateRingSeriesPreview;
  });

  function renderRingSeriesList() {
    const ids = Object.keys(ringSeriesList).sort((a, b) => (ringSeriesList[b].year || 0) - (ringSeriesList[a].year || 0));
    const countEl = document.getElementById('ringseries-count');
    if (countEl) countEl.textContent = ids.length ? `(${ids.length})` : '';
    const grid = document.getElementById('ringseries-grid');
    const empty = document.getElementById('ringseries-empty');
    if (!grid || !empty) return;
    if (ids.length === 0) {
      empty.style.display = 'block';
      grid.innerHTML = '';
      return;
    }
    empty.style.display = 'none';
    const myPigeons = allPigeonDocs.filter(d => d.p.orgId === currentOrg.slug);
    grid.innerHTML = ids.map(id => {
      const rs = ringSeriesList[id];
      const total = rs.endNum - rs.startNum + 1;
      const usedCount = myPigeons.filter(d => isRingInSeries(d.p.ringNumber, rs)).length;
      return `
        <div class="ltc-card" data-id="${id}">
          <div class="ltc-card-title">
            <span class="ltc-card-title-text" style="font-size:15px;"><i class="fa-solid fa-ring" style="color:#2f6fed;"></i> ${rs.label || (rs.clubCode + '-' + rs.year)}</span>
            <button type="button" class="ltc-kebab-btn rs-kebab-btn" aria-label="More actions"><i class="fa-solid fa-ellipsis-vertical"></i></button>
          </div>
          <div class="ltc-kebab-menu">
            <div class="ltc-kebab-menu-item danger rs-delete-item"><i class="fa-solid fa-trash"></i> Delete</div>
          </div>
          <div class="ltc-card-row"><i class="fa-solid fa-hashtag"></i><span>${rs.clubCode}-${rs.year}-${String(rs.startNum).padStart(4, '0')} to ${rs.clubCode}-${rs.year}-${String(rs.endNum).padStart(4, '0')}</span></div>
          <div class="ltc-card-row"><i class="fa-solid fa-list-ol"></i><span>${usedCount} used of ${total}</span></div>
        </div>
      `;
    }).join('');
    grid.querySelectorAll('.ltc-card').forEach(card => {
      const id = card.dataset.id;
      const kebabBtn = card.querySelector('.rs-kebab-btn');
      const kebabMenu = card.querySelector('.ltc-kebab-menu');
      kebabBtn.onclick = (e) => {
        e.stopPropagation();
        const wasOpen = kebabMenu.classList.contains('open');
        document.querySelectorAll('.ltc-kebab-menu.open').forEach(m => m.classList.remove('open'));
        if (!wasOpen) { kebabMenu.classList.add('open'); keepKebabMenuInView(kebabMenu); }
      };
      card.querySelector('.rs-delete-item').onclick = async () => {
        kebabMenu.classList.remove('open');
        if (!(await showConfirmModal('Delete this ring series? This does not affect any pigeons already using a ring number from it.', 'Delete ring series?'))) return;
        try {
          await db.collection('ringSeries').doc(id).delete();
          delete ringSeriesList[id];
          renderRingSeriesList();
          populateRingSeriesPicker();
          showToast('🗑️ Ring series deleted');
        } catch (e) { showToast('Could not delete: ' + e.message); }
      };
    });
  }

  function openRingSeriesPage() {
    renderRingSeriesList();
    document.querySelectorAll('.db-nav-item, .db-mobile-tab').forEach(i => i.classList.remove('active'));
    document.querySelectorAll('.db-panel').forEach(p => p.classList.remove('active'));
    document.getElementById('db-panel-ring-series').classList.add('active');
    const contentEl = document.querySelector('.db-content');
    if (contentEl) contentEl.scrollTop = 0;
  }
  const pigeonRingSeriesBtn = document.getElementById('pigeon-ringseries-btn');
  if (pigeonRingSeriesBtn) pigeonRingSeriesBtn.onclick = openRingSeriesPage;
  const ringSeriesBackBtn = document.getElementById('ringseries-back-btn');
  if (ringSeriesBackBtn) ringSeriesBackBtn.onclick = () => activateTab('pigeon-list');
  setupDismissableBanners(['ringseries-info-banner'], 'ringseries-banner-restore-btn', 'fpl-ringseries-banners-dismissed');

  // Add Ring Series is a modal now (matching every other "+ Add" flow in
  // the app) instead of an inline form -- the inline grid didn't lay out
  // side-by-side the way it was meant to.
  function openAddRingSeriesModal() {
    document.getElementById('rs-label').value = '';
    document.getElementById('rs-clubcode').value = '';
    document.getElementById('rs-year').value = '';
    document.getElementById('rs-start').value = '';
    document.getElementById('rs-end').value = '';
    document.getElementById('rs-status-msg').textContent = '';
    updateRingSeriesPreview();
    document.getElementById('db-ringseries-modal').classList.add('open');
  }
  const rsAddBtn = document.getElementById('rs-add-btn');
  if (rsAddBtn) rsAddBtn.onclick = openAddRingSeriesModal;
  const rsCancelBtn = document.getElementById('rs-cancel');
  if (rsCancelBtn) rsCancelBtn.onclick = () => document.getElementById('db-ringseries-modal').classList.remove('open');
  const rsSaveBtn = document.getElementById('rs-save-btn');
  if (rsSaveBtn) rsSaveBtn.onclick = async () => {
    const statusEl = document.getElementById('rs-status-msg');
    const label = document.getElementById('rs-label').value.trim();
    const clubCode = document.getElementById('rs-clubcode').value.trim();
    const year = document.getElementById('rs-year').value.trim();
    const startNum = parseInt(document.getElementById('rs-start').value, 10);
    const endNum = parseInt(document.getElementById('rs-end').value, 10);
    if (!clubCode || !year || !startNum || !endNum || endNum < startNum) {
      statusEl.textContent = 'Club code, year, start and end are required (end must be at least start).';
      statusEl.style.color = '#c0392b';
      showToast('⚠️ Fill in club code, year, start and end');
      return;
    }
    statusEl.textContent = 'Saving...';
    statusEl.style.color = '#6b7a87';
    try {
      const data = { label, clubCode, year, startNum, endNum, orgId: currentOrg.slug, ownerUid: auth.currentUser.uid };
      const ref = await db.collection('ringSeries').add({ ...data, createdAt: firebase.firestore.FieldValue.serverTimestamp() });
      ringSeriesList[ref.id] = data;
      renderRingSeriesList();
      populateRingSeriesPicker();
      showToast('✅ Ring series added');
      document.getElementById('db-ringseries-modal').classList.remove('open');
    } catch (e) {
      statusEl.textContent = e.message;
      statusEl.style.color = '#c0392b';
      showToast('❌ Could not save: ' + e.message);
    }
  };

  let pigeonsByTracker = {};        // this user's own pigeons -- keyed by assignedTrackerId (rawId)
  let globalPigeonsByTracker = {};  // EVERY user's pigeons -- keyed by assignedTrackerId, used for matching trackers on the live map

  // Normalizes a MAC string for comparison -- strips colons/dashes/spaces
  // and lowercases. Still used when looking up a tracker doc by MAC (e.g.
  // Add Tracker's input), just no longer used for pigeon matching now that
  // pigeon<->tracker is a direct assignedTrackerId link, not a string match.
  function normKey(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  // Listens to ALL pigeons from ALL users, so a tracker can match a pigeon
  // even if a different account added it (shared matching, as requested).
  function listenForGlobalPigeons() {
    db.collection('pigeons').onSnapshot(snapshot => {
      globalPigeonsByTracker = {};
      snapshot.forEach(doc => {
        const p = doc.data();
        if (p.assignedTrackerId) globalPigeonsByTracker[p.assignedTrackerId] = { id: doc.id, ...p };
      });
    });
  }

  // All currently-loaded pigeons (unfiltered) -- kept separately from what's
  // actually rendered, so searching never affects tracker/pigeon matching
  // elsewhere (pigeonsByTracker always reflects every pigeon, search only
  // changes what's shown in the grid).
  let allPigeonDocs = [];

  // Admin-only: every organization's name/email, keyed by slug, so a
  // foreign pigeon's owner can be shown directly on its card (name + email)
  // without needing a separate "who?" lookup click.
  let orgsBySlug = {};

  function listenForAllOrganizations() {
    db.collection('organizations').onSnapshot(snapshot => {
      orgsBySlug = {};
      snapshot.forEach(doc => { orgsBySlug[doc.data().slug] = doc.data(); });
      applyPigeonSearch();
    });
  }

  let pigeonsPerPage = 20;
  let currentPigeonPage = 1;
  let pigeonStatusFilter = 'all'; // 'all' | 'assigned' | 'unassigned'
  let pigeonSexFilter = 'all'; // 'all' | 'cock' | 'hen' | 'unknown'
  let pigeonArchiveTab = 'active'; // 'active' | 'archived'
  let trackerStatusFilter = 'all'; // 'all' | 'active' | 'calm'
  let trackerAssignmentFilter = 'all'; // 'all' | 'assigned' | 'unassigned'
  let trackersPerPage = 20;
  let currentTrackerPage = 1;
  let groupsPerPage = 20;
  let currentGroupPage = 1;
  let grpStatusFilter = 'all';
  let grpOwnerFilter = 'all';
  let grpSortMode = 'latest';

  // Pigeon List summary cards, computed from the full loaded list (the same
  // allPigeonDocs the list and the sidebar count use), so they always match it:
  // Total = every pigeon, Males/Females = by sex, Young Birds = born within the
  // last 12 months (needs a Date of Birth), Inactive = marked Inactive.
  function updatePigeonSummaryCards() {
    const now = Date.now();
    const oneYearMs = 365.25 * 24 * 60 * 60 * 1000;
    let males = 0, females = 0, young = 0, inactive = 0;
    allPigeonDocs.forEach(({ p }) => {
      if (p.sex === 'cock') males++;
      else if (p.sex === 'hen') females++;
      if (p.isArchived) inactive++;
      if (p.dateOfBirth) {
        const born = new Date(p.dateOfBirth).getTime();
        if (!isNaN(born) && born <= now + 24 * 60 * 60 * 1000 && now - born < oneYearMs) young++;
      }
    });
    const set = (id, n) => { const el = document.getElementById(id); if (el) el.textContent = n; };
    set('pgn-stat-total', allPigeonDocs.length);
    set('pgn-stat-males', males);
    set('pgn-stat-females', females);
    set('pgn-stat-young', young);
    set('pgn-stat-inactive', inactive);
  }

  function applyPigeonSearch() {
    updatePigeonSummaryCards();
    // Active/Archived tab counts, always computed against the full list
    // (not whatever's currently search/status/sex-filtered) so they read
    // as "how many total", matching Trainings/Ace's own count badges.
    const activeCount = allPigeonDocs.filter(({ p }) => !p.isArchived).length;
    const archivedCount = allPigeonDocs.length - activeCount;
    const activeCountEl = document.getElementById('pigeon-tab-active-count');
    const archivedCountEl = document.getElementById('pigeon-tab-archived-count');
    if (activeCountEl) activeCountEl.textContent = activeCount;
    if (archivedCountEl) archivedCountEl.textContent = archivedCount;

    const archiveFiltered = allPigeonDocs.filter(({ p }) => !!p.isArchived === (pigeonArchiveTab === 'archived'));
    const term = document.getElementById('db-pigeon-search').value.trim().toLowerCase();
    const searchFiltered = !term ? archiveFiltered : archiveFiltered.filter(({ p }) => {
      if ((p.name || '').toLowerCase().includes(term)) return true;
      if ((p.ringNumber || '').toLowerCase().includes(term)) return true;
      // Tracker tag: the assigned tracker's ID or its nickname. The ID also
      // matches without colons/dashes/spaces, same as the Trackers tab's own
      // search, so a MAC typed either way still finds the bird.
      if (p.assignedTrackerId) {
        const tagId = String(p.assignedTrackerId).toLowerCase();
        const tagNickname = ((registry[p.assignedTrackerId] && registry[p.assignedTrackerId].nickname) || '').toLowerCase();
        const normalizedTerm = term.replace(/[:\-\s]/g, '');
        if (tagId.includes(term) || tagNickname.includes(term)) return true;
        if (normalizedTerm && tagId.replace(/[:\-\s]/g, '').includes(normalizedTerm)) return true;
      }
      // Account/account-owner matching is an admin-only search dimension --
      // regular users only ever see their own org's pigeons anyway, so
      // matching on account would be a no-op for them.
      if (!isAdmin) return false;
      const owner = orgsBySlug[p.orgId] || null;
      return ((owner && owner.name) || '').toLowerCase().includes(term) ||
        ((owner && owner.ownerEmail) || '').toLowerCase().includes(term);
    });
    // Status filter (All / Assigned / Unassigned), applied on top of the
    // search match -- "assigned" means the pigeon's assignedTrackerId
    // actually resolves to a real tracker in registry, same reasoning as
    // the equivalent Trackers-tab filter (a stale id shouldn't count).
    const statusFiltered = pigeonStatusFilter === 'all' ? searchFiltered : searchFiltered.filter(({ p }) => {
      const isAssigned = !!(p.assignedTrackerId && registry[p.assignedTrackerId]);
      return pigeonStatusFilter === 'assigned' ? isAssigned : !isAssigned;
    });
    // Sex filter (All / Cock / Hen / Unknown), stacked on top of the above --
    // "unknown" catches pigeons with no sex set at all, not just a literal
    // 'unknown' value, since most birds simply never had it filled in.
    const filtered = pigeonSexFilter === 'all' ? statusFiltered : statusFiltered.filter(({ p }) => {
      if (pigeonSexFilter === 'unknown') return p.sex !== 'cock' && p.sex !== 'hen';
      return p.sex === pigeonSexFilter;
    });
    renderPigeonGrid(filtered);
  }

  function renderPigeonGrid(allFilteredDocs) {
    const grid = document.getElementById('db-pigeon-grid');
    const empty = document.getElementById('db-pigeon-empty');
    const paginationEl = document.getElementById('db-pigeon-pagination');
    document.getElementById('db-pigeon-count').textContent = '(' + allPigeonDocs.length + ')';
    document.getElementById('db-nav-pigeon-count').textContent = allPigeonDocs.length || '';

    // Same reasoning as the Trackers tab: regular accounts rarely have
    // more than 20 pigeons, so the per-page selector is just clutter until
    // they actually have enough to paginate meaningfully. Admins always
    // see it. Doesn't touch the pagination buttons themselves.
    const rowsWrap = document.getElementById('pgn-rows-wrap');
    if (rowsWrap) rowsWrap.style.display = (isAdmin || allPigeonDocs.length > 20) ? '' : 'none';
    const showingEl = document.getElementById('db-pigeon-showing');
    if (showingEl) showingEl.textContent = '';

    if (allFilteredDocs.length === 0) {
      grid.innerHTML = '';
      paginationEl.innerHTML = '';
      empty.style.display = 'block';
      empty.innerHTML = allPigeonDocs.length === 0
        ? '<b>You currently have no pigeons in the system.</b> Click "+ Add Pigeon" above to add your first one.'
        : '<b>No pigeons match your search.</b>';
      return;
    }
    empty.style.display = 'none';

    const totalPages = pigeonsPerPage === Infinity ? 1 : Math.max(1, Math.ceil(allFilteredDocs.length / pigeonsPerPage));
    if (currentPigeonPage > totalPages) currentPigeonPage = totalPages;
    const startIdx = pigeonsPerPage === Infinity ? 0 : (currentPigeonPage - 1) * pigeonsPerPage;
    const docs = pigeonsPerPage === Infinity ? allFilteredDocs : allFilteredDocs.slice(startIdx, startIdx + pigeonsPerPage);

    renderPigeonPagination(totalPages);
    if (showingEl) {
      showingEl.textContent = 'Showing ' + (startIdx + 1) + ' to ' + (startIdx + docs.length) + ' of ' + allFilteredDocs.length +
        ' pigeon' + (allFilteredDocs.length !== 1 ? 's' : '');
    }
    grid.innerHTML = '';
    docs.forEach(({ id, p }) => {
        const assignedTracker = p.assignedTrackerId ? registry[p.assignedTrackerId] : null;
        // "Live" = its assigned tracker's last report was within 24h --
        // read straight off the registry, no separate live-stream needed.
        const isLive = !!(assignedTracker && typeof assignedTracker.lastVernalTimestamp === 'number' &&
          (Date.now() - assignedTracker.lastVernalTimestamp) < 24 * 60 * 60 * 1000);
        const trackerLabel = p.assignedTrackerId
          ? (assignedTracker ? (assignedTracker.nickname || p.assignedTrackerId) : p.assignedTrackerId)
          : 'No tracker assigned';
        const card = document.createElement('div');
        card.className = 'pgn-card' + (p.isArchived ? ' pgn-card--inactive' : '');
        const initials = (p.name || '?').trim().split(/\s+/).map(w => w[0]).slice(0, 2).join('').toUpperCase() || '?';
        const avatarColor = p.markerColor || '#2f6fed';
        const ageLabel = pigeonAgeLabel(p.dateOfBirth);
        const lastSeenLabel = assignedTracker && typeof assignedTracker.lastVernalTimestamp === 'number'
          ? timeAgo(assignedTracker.lastVernalTimestamp) : null;
        const sexIcon = p.sex === 'cock' ? '<i class="fa-solid fa-mars" style="color:#2f6fed;"></i>'
          : p.sex === 'hen' ? '<i class="fa-solid fa-venus" style="color:#d6336c;"></i>'
          : '<i class="fa-solid fa-circle-question"></i>';
        const sexLabel = p.sex === 'cock' ? 'Cock' : p.sex === 'hen' ? 'Hen' : 'Sex unknown';
        const sire = p.sireId ? findPigeonDoc(p.sireId) : null;
        const dam = p.damId ? findPigeonDoc(p.damId) : null;
        card.innerHTML = `
          <div class="pgn-card-main">
            <div class="pgn-photo" style="background:${avatarColor};">
              <span class="pgn-photo-initials">${initials}</span>
              ${p.photoURL ? `<img src="${p.photoURL}" alt="" onerror="this.style.display='none'">` : ''}
            </div>
            <div class="pgn-info">
              <div class="pgn-top">
                <div class="pgn-id">
                  <div class="pgn-name">${p.name}${isLive ? '<span class="pigeon-live-dot" title="Live"></span>' : ''}</div>
                  <div class="pgn-ring${p.ringNumber ? '' : ' pgn-ring--none'}">${p.ringNumber ? p.ringNumber : 'No ring number'}</div>
                </div>
                <button type="button" class="ltc-kebab-btn pgn-kebab" aria-label="More actions"><i class="fa-solid fa-ellipsis-vertical"></i></button>
              </div>
              <div class="pgn-meta">
                <div class="pgn-meta-row">${sexIcon}<span>${sexLabel}</span></div>
                ${p.color ? `<div class="pgn-meta-row"><i class="fa-solid fa-palette"></i><span>Color: ${p.color}</span></div>` : ''}
                ${p.assignedTrackerId
                  ? `<div class="pgn-meta-row pgn-meta-row--trk" role="button" tabindex="0" title="View ${trackerLabel} on the map${lastSeenLabel ? ' (last seen ' + lastSeenLabel + ')' : ''}"><i class="fa-solid fa-map-location-dot"></i><span>Tracker: <u class="pgn-trk-name">${trackerLabel}</u></span></div>`
                  : '<div class="pgn-meta-row"><i class="fa-solid fa-satellite-dish"></i><span>Tracker: Not assigned</span></div>'}
                ${ageLabel ? `<div class="pgn-meta-row"><i class="fa-regular fa-clock"></i><span>${ageLabel}</span></div>` : ''}
                ${(sire || dam) ? `<div class="pgn-meta-row"><i class="fa-solid fa-people-roof"></i><span>${sire ? sire.p.name : '?'} &times; ${dam ? dam.p.name : '?'}</span></div>` : ''}
              </div>
            </div>
          </div>
          <div class="ltc-kebab-menu">
            <div class="ltc-kebab-menu-item pgn-assign-item"><i class="fa-solid fa-satellite-dish"></i> ${p.assignedTrackerId ? 'Unassign tracker' : 'Assign tracker'}</div>
            ${isAdmin && p.assignedTrackerId ? '<div class="ltc-kebab-menu-item pgn-map-item"><i class="fa-solid fa-map-location-dot"></i> View map</div>' : ''}
            <div class="ltc-kebab-menu-divider"></div>
            <div class="ltc-kebab-menu-item pgn-copy-item"><i class="fa-solid fa-copy"></i> Copy Pigeon</div>
            <div class="ltc-kebab-menu-item pgn-share-item"><i class="fa-solid fa-share-nodes"></i> Share Pigeon</div>
          </div>
          <div class="pgn-card-foot">
            <span class="pgn-badge ${p.isArchived ? 'pgn-badge--inactive' : 'pgn-badge--active'}">${p.isArchived ? 'Inactive' : 'Active'}</span>
            <div class="pgn-actions">
              <button type="button" class="pgn-act pgn-details-btn"><i class="fa-solid fa-circle-info"></i> Details</button>
              <button type="button" class="pgn-act pgn-view-btn"><i class="fa-solid fa-sitemap"></i> Pedigree</button>
              <button type="button" class="pgn-act pgn-edit-btn"><i class="fa-solid fa-pen"></i> Edit</button>
              <button type="button" class="pgn-act pgn-act--danger pgn-delete-btn"><i class="fa-solid fa-trash"></i> Delete</button>
            </div>
          </div>
          ${isAdmin && p.orgId !== currentOrg.slug ? (() => {
            const owner = orgsBySlug[p.orgId] || null;
            return `
              <div class="pigeon-admin-owner">
                <div class="pigeon-admin-owner-name">${owner ? owner.name : 'Account record missing'}</div>
                <div class="pigeon-admin-owner-email">${owner ? (owner.ownerEmail || '—') : p.orgId}</div>
                <button class="pigeon-remove-account-btn" data-org="${p.orgId}" data-uid="${p.ownerUid || ''}">Remove Account</button>
              </div>
            `;
          })() : ''}
        `;
        const kebabBtn = card.querySelector('.ltc-kebab-btn');
        const kebabMenu = card.querySelector('.ltc-kebab-menu');
        kebabBtn.onclick = (e) => {
          e.stopPropagation();
          const wasOpen = kebabMenu.classList.contains('open');
          document.querySelectorAll('.ltc-kebab-menu.open').forEach(m => m.classList.remove('open'));
          if (!wasOpen) { kebabMenu.classList.add('open'); keepKebabMenuInView(kebabMenu); }
        };
        card.querySelector('.pgn-details-btn').onclick = () => openPigeonDetailsPage(id, p, 'pigeon-list');
        card.querySelector('.pgn-view-btn').onclick = () => openPigeonPedigreePage(id, p, 'pigeon-list');
        card.querySelector('.pgn-edit-btn').onclick = () => openEditModal(id, p);
        card.querySelector('.pgn-delete-btn').onclick = () => deletePigeon(id, p.name, p.assignedTrackerId);
        card.querySelector('.pgn-copy-item').onclick = () => {
          kebabMenu.classList.remove('open');
          copyPigeon(p);
        };
        card.querySelector('.pgn-share-item').onclick = () => {
          kebabMenu.classList.remove('open');
          showToast('Sharing pigeons with another account isn\'t built yet.');
        };
        card.querySelector('.pgn-assign-item').onclick = () => {
          kebabMenu.classList.remove('open');
          if (p.assignedTrackerId) {
            unassignTracker(p.assignedTrackerId, id);
          } else {
            openAssignTrackerModal(id, p.name);
          }
        };
        const openTrackerMap = () => {
          kebabMenu.classList.remove('open');
          ntEntryTab = 'pigeon-list';
          activateTab('new-track');
          document.getElementById('nt-tracker-select').value = p.assignedTrackerId;
          loadNewTrack();
        };
        const mapItem = card.querySelector('.pgn-map-item');
        if (mapItem) mapItem.onclick = openTrackerMap;
        // The assigned-tracker row on the card itself is a link to the same map.
        const trkRow = card.querySelector('.pgn-meta-row--trk');
        if (trkRow) {
          trkRow.onclick = openTrackerMap;
          trkRow.onkeydown = (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openTrackerMap(); } };
        }
        const removeBtn = card.querySelector('.pigeon-remove-account-btn');
        if (removeBtn) {
          removeBtn.onclick = async () => {
            const owner = orgsBySlug[removeBtn.dataset.org];
            const uid = removeBtn.dataset.uid;
            if (!owner && !uid) {
              alert('No account info available to remove for this pigeon.');
              return;
            }
            const confirmed = await showConfirmModal(
              (owner
                ? 'Name: ' + (owner.name || '—') + '\nEmail: ' + (owner.ownerEmail || '—') + '\n\n'
                : 'This account\'s organization record is already missing -- removing by owner ID instead.\n\n') +
              'This deletes ALL of their pigeons, their account record (if any), and their login ' +
              '(they will not be able to sign in again with this email). This cannot be undone.',
              'PERMANENTLY remove this account?'
            );
            if (!confirmed) return;

            const originalText = removeBtn.textContent;
            removeBtn.textContent = 'Removing...';
            removeBtn.disabled = true;
            try {
              const idToken = await auth.currentUser.getIdToken();
              const resp = await fetch('https://us-central1-flightpathlive-24331.cloudfunctions.net/removeAccountByEmail', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + idToken
                },
                body: JSON.stringify(owner ? { email: owner.ownerEmail } : { uid })
              }).then(r => r.json());

              if (resp.ok) {
                alert('Removed. Deleted ' + resp.deletedPigeons + ' pigeon(s) and the account record. Login deleted: ' + resp.authDeleted);
              } else {
                alert('Removal failed: ' + resp.message);
                removeBtn.textContent = originalText;
                removeBtn.disabled = false;
              }
            } catch (err) {
              alert('Removal failed: ' + err.message);
              removeBtn.textContent = originalText;
              removeBtn.disabled = false;
            }
          };
        }
        grid.appendChild(card);
    });
  }

  function renderPigeonPagination(totalPages) {
    const el = document.getElementById('db-pigeon-pagination');
    if (totalPages <= 1) {
      el.innerHTML = '';
      return;
    }
    el.innerHTML = '';

    const prevBtn = document.createElement('button');
    prevBtn.textContent = '← Prev';
    prevBtn.disabled = currentPigeonPage === 1;
    prevBtn.onclick = () => { currentPigeonPage--; applyPigeonSearch(); };
    el.appendChild(prevBtn);

    for (let i = 1; i <= totalPages; i++) {
      const pageBtn = document.createElement('button');
      pageBtn.textContent = i;
      if (i === currentPigeonPage) pageBtn.className = 'active';
      pageBtn.onclick = () => { currentPigeonPage = i; applyPigeonSearch(); };
      el.appendChild(pageBtn);
    }

    const nextBtn = document.createElement('button');
    nextBtn.textContent = 'Next →';
    nextBtn.disabled = currentPigeonPage === totalPages;
    nextBtn.onclick = () => { currentPigeonPage++; applyPigeonSearch(); };
    el.appendChild(nextBtn);
  }

  document.getElementById('db-pigeon-search').oninput = () => {
    currentPigeonPage = 1; // a new search always starts back on page 1
    applyPigeonSearch();
  };

  document.getElementById('db-pigeon-per-page').onchange = (e) => {
    pigeonsPerPage = e.target.value === 'all' ? Infinity : parseInt(e.target.value, 10);
    currentPigeonPage = 1;
    applyPigeonSearch();
  };

  document.getElementById('db-pigeon-status-filter').onchange = (e) => {
    pigeonStatusFilter = e.target.value;
    currentPigeonPage = 1;
    applyPigeonSearch();
  };

  document.getElementById('db-pigeon-sex-filter').onchange = (e) => {
    pigeonSexFilter = e.target.value;
    currentPigeonPage = 1;
    applyPigeonSearch();
  };

  document.querySelectorAll('.pigeon-archive-tab').forEach(tab => {
    tab.onclick = () => {
      pigeonArchiveTab = tab.dataset.archived === 'true' ? 'archived' : 'active';
      currentPigeonPage = 1;
      document.querySelectorAll('.pigeon-archive-tab').forEach(t => t.classList.toggle('active', t === tab));
      updatePigeonInactiveBannerVisibility();
      applyPigeonSearch();
    };
  });

  function listenForPigeons() {
    // Admin sees every account's pigeons; everyone else only their own.
    const query = isAdmin
      ? db.collection('pigeons')
      : db.collection('pigeons').where('orgId', '==', currentOrg.slug);

    query.onSnapshot(snapshot => {
      pigeonsByTracker = {};
      allPigeonDocs = [];
      snapshot.forEach(doc => {
        const p = doc.data();
        if (p.assignedTrackerId) pigeonsByTracker[p.assignedTrackerId] = { id: doc.id, ...p };
        allPigeonDocs.push({ id: doc.id, p });
      });
      applyPigeonSearch();
      updateTrackerNavCount();
      if (document.getElementById('db-panel-trackers').classList.contains('active')) applyTrackerSearch();
      if (document.getElementById('db-panel-pairs').classList.contains('active')) renderPairsList();
      populateRingSeriesPicker();
      if (document.getElementById('db-panel-ring-series').classList.contains('active')) renderRingSeriesList();
      if (document.getElementById('db-panel-home').classList.contains('active')) renderHomeTab();
    });
  }

  // registry: rawId -> tracker doc data (from `trackers` collection).
  // Shared by Trackers tab, New Track, and Pigeon List's tracker-assignment
  // display.
  const registry = {};

  function filterOutliers(points, maxMph = 90) {
    if (points.length < 2) return points;
    const R = 3958.8;
    const kept = [points[0]];
    for (let i = 1; i < points.length; i++) {
      const prev = kept[kept.length - 1];
      const cur = points[i];
      const dtHours = (cur.t - prev.t) / 3600000;
      if (dtHours <= 0) { kept.push(cur); continue; }
      const dLat = (cur.lat - prev.lat) * Math.PI / 180;
      const dLng = (cur.lng - prev.lng) * Math.PI / 180;
      const a = Math.sin(dLat/2)**2 + Math.cos(prev.lat*Math.PI/180) * Math.cos(cur.lat*Math.PI/180) * Math.sin(dLng/2)**2;
      const distMiles = R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      if (distMiles / dtHours <= maxMph) kept.push(cur);
    }
    return kept;
  }

  // TEMP DASHBOARD: pigeon<->tracker is now a direct link -- a pigeon's
  // `assignedTrackerId` field holds the tracker's rawId (doc ID in the
  // `trackers` collection) directly, set/cleared by the Assign/Unassign
  // Tracker actions. No more Ring Number string-matching against MAC/rawId.
  function matchedPigeon(rawId) {
    if (!rawId) return null;
    return globalPigeonsByTracker[rawId] || null;
  }

  function myMatchedPigeon(rawId) {
    if (!rawId) return null;
    return pigeonsByTracker[rawId] || null;
  }

  // Used by New Track's history table.
  function fmtTime(ms) {
    return new Date(ms).toLocaleString('en-GB', { timeZone: 'Europe/London' });
  }

  // Generic toast -- one shared #db-toast element (see the liquid file),
  // reused for any brief confirmation message rather than each feature
  // wiring its own fade timer. A second call while one is still showing
  // just resets the message/timer instead of stacking multiple toasts.
  let toastHideTimer = null;
  function showToast(message, durationMs) {
    const el = document.getElementById('db-toast');
    if (!el) return;
    clearTimeout(toastHideTimer);
    el.textContent = message;
    el.classList.add('show');
    toastHideTimer = setTimeout(() => el.classList.remove('show'), durationMs || 2500);
  }

  // Replaces window.confirm() everywhere -- the browser's own version shows
  // the raw page URL ("www.flightpathlive.com says...") and looks jarring
  // next to the rest of the app's own UI. One shared modal, re-wired fresh
  // on each call (only one confirm is ever open at a time, so overwriting
  // the previous call's handlers is safe) instead of each delete/remove/end
  // action building its own dialog. Resolves true (OK) or false
  // (Cancel/closed) -- callers use it exactly like the old
  // `if (!confirm(...)) return;` pattern, just with `await` in front.
  function showConfirmModal(message, title, okLabel) {
    return new Promise(resolve => {
      const modal = document.getElementById('db-confirm-modal');
      document.getElementById('db-confirm-title').textContent = title || 'Are you sure?';
      document.getElementById('db-confirm-message').textContent = message;
      document.getElementById('db-confirm-ok').textContent = okLabel || 'OK';
      const cleanup = (result) => {
        modal.classList.remove('open');
        resolve(result);
      };
      document.getElementById('db-confirm-ok').onclick = () => cleanup(true);
      document.getElementById('db-confirm-cancel').onclick = () => cleanup(false);
      modal.classList.add('open');
    });
  }

  // Generic top-right "X" on every modal -- one delegated click handler
  // instead of each of the app's modals wiring its own close button.
  // Closes whichever .db-modal-overlay the clicked X happens to be inside.
  // .db-modal-mback is the same close action, just shown as a "←" at the
  // top-left on phones (mobile-only via CSS) instead of/alongside the "×".
  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('.db-modal-close, .db-modal-mback');
    if (!closeBtn) return;
    const overlay = closeBtn.closest('.db-modal-overlay');
    if (overlay) overlay.classList.remove('open');
  });

  // Training speed is stored internally as km/h (speedKmH) but always
  // displayed in meters/min, matching the competitor's own convention.
  function speedToMPerMin(speedKmH) {
    return speedKmH * 1000 / 60;
  }

  // "08 Aug 2026 16:15" style, used by Group Tracking's date-range header line.
  function fmtDateShort(ms) {
    return new Date(ms).toLocaleString('en-GB', {
      day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
      hour12: false, timeZone: 'Europe/London'
    }).replace(',', '');
  }

  function timeAgo(ms) {
    const s = Math.floor((Date.now() - ms) / 1000);
    if (s < 60) return s + 's ago';
    const m = Math.floor(s / 60);
    if (m < 60) return m + 'm ago';
    return Math.floor(m / 60) + 'h ago';
  }

  // "2 yrs old" / "5 months old" pill text for a pigeon's dateOfBirth
  // (stored as the plain "YYYY-MM-DD" string an <input type="date"> gives).
  function pigeonAgeLabel(dob) {
    if (!dob) return null;
    const birth = new Date(dob);
    if (isNaN(birth.getTime())) return null;
    const now = new Date();
    let years = now.getFullYear() - birth.getFullYear();
    const hadBirthdayThisYear = (now.getMonth() > birth.getMonth()) ||
      (now.getMonth() === birth.getMonth() && now.getDate() >= birth.getDate());
    if (!hadBirthdayThisYear) years--;
    if (years < 1) {
      let months = (now.getFullYear() - birth.getFullYear()) * 12 + (now.getMonth() - birth.getMonth());
      if (now.getDate() < birth.getDate()) months--;
      months = Math.max(0, months);
      return months === 0 ? 'Under a month old' : months + (months === 1 ? ' month old' : ' months old');
    }
    return years + (years === 1 ? ' yr old' : ' yrs old');
  }

  // Simulated "Checked" ticker -- the poller genuinely does re-check every
  // tracker every ~2 minutes, but writing a real per-tracker "last checked"
  // timestamp to Firestore for that costs a write per idle tracker per
  // cycle (rejected earlier on cost grounds). This fakes the same visual
  // effect client-side instead: each tracker gets its own independently
  // ticking "seconds since checked", staggered on first render so they
  // don't all show the same value, wrapping back to "just now" every ~2
  // minutes to match the real cadence -- purely cosmetic, no backend cost.
  const fakeCheckedSeconds = {}; // rawId -> seconds since its simulated last-check

  function fakeCheckedLabel(rawId) {
    if (!(rawId in fakeCheckedSeconds)) {
      fakeCheckedSeconds[rawId] = Math.floor(Math.random() * 110); // stagger so cards don't tick in sync
    }
    const s = fakeCheckedSeconds[rawId];
    if (s < 10) return 'just now';
    if (s < 60) return s + 's ago';
    return Math.floor(s / 60) + 'm ago';
  }

  setInterval(() => {
    Object.keys(fakeCheckedSeconds).forEach(rawId => {
      fakeCheckedSeconds[rawId] += 2;
      if (fakeCheckedSeconds[rawId] > 118) fakeCheckedSeconds[rawId] = 0; // simulate the poller having just re-checked it
    });
    document.querySelectorAll('.trk-checked-text').forEach(el => {
      el.textContent = fakeCheckedLabel(el.dataset.rawid);
    });
  }, 2000);

  // Core listeners every tab depends on: pigeons (for matching) and
  // trackers (registry -- battery/location/assignment status shown across
  // Pigeon List, Trackers tab, and New Track).
  // rawId -> membership doc id ("trk-add-btn" writes one per org when a
  // tracker is added). Any number of orgs can hold a membership on the same
  // tracker at once -- each org only ever sees/removes their OWN membership,
  // never anyone else's, and never touches the shared trackers doc itself.
  const myTrackerMemberships = {};
  const allMembershipDocIds = new Set(); // every doc id this org has ever had, active OR removed -- persists the fact "we've seen this before" across reloads (unlike the old session-only Set)
  const backfilledMemberships = new Set(); // rawIds already attempted this session -- avoids re-writing on every snapshot
  let registryLoaded = false;
  let membershipsLoaded = false;

  function trackerMembershipDocId(rawId) {
    return rawId + '__' + currentOrg.slug;
  }

  // One-time backfill: trackers added BEFORE the trackerMemberships model
  // existed still have the old `orgId` field set but never got a membership
  // doc created for them -- without this they'd silently vanish from this
  // org's Trackers tab even though nothing was deleted. Gated on BOTH
  // listeners having loaded at least once, so it can see the full set of
  // membership doc ids (including removed/tombstoned ones) before deciding
  // what's actually missing -- otherwise a tracker the user just Removed
  // would look "missing" during the moment before the memberships listener's
  // first snapshot arrives, and get silently re-added on every reload.
  function maybeRunMembershipBackfill() {
    if (!registryLoaded || !membershipsLoaded) return;
    Object.keys(registry).forEach(rawId => {
      const data = registry[rawId];
      const docId = trackerMembershipDocId(rawId);
      if (data.orgId === currentOrg.slug && !allMembershipDocIds.has(docId) && !backfilledMemberships.has(rawId)) {
        backfilledMemberships.add(rawId);
        allMembershipDocIds.add(docId);
        db.collection('trackerMemberships').doc(docId).set({
          trackerId: rawId,
          orgId: currentOrg.slug,
          addedAt: firebase.firestore.FieldValue.serverTimestamp()
        }).catch(e => console.warn('Membership backfill failed for', rawId, e.message));
      }
    });
  }

  function startCoreListeners() {
    listenForGlobalPigeons();

    // Unscoped (no orgId filter) so a match works no matter which account
    // registered the tracker vs which account added the matching pigeon.
    db.collection('trackers').onSnapshot(snapshot => {
      snapshot.forEach(doc => { registry[doc.id] = doc.data(); });
      registryLoaded = true;
      maybeRunMembershipBackfill();
      if (isAdmin) populateNewTrackDropdown();
      updateTrackerNavCount();
      if (document.getElementById('db-panel-trackers').classList.contains('active')) applyTrackerSearch();
      // Refresh Pigeon List cards too -- their "Live"/tracker-status badges
      // read straight from `registry`, not from a separate live-stream.
      if (document.getElementById('db-panel-pigeon-list').classList.contains('active')) applyPigeonSearch();
      if (document.getElementById('db-panel-home').classList.contains('active')) renderHomeTab();
    });

    db.collection('trackerMemberships').where('orgId', '==', currentOrg.slug).onSnapshot(snapshot => {
      for (const key in myTrackerMemberships) delete myTrackerMemberships[key];
      allMembershipDocIds.clear();
      snapshot.forEach(doc => {
        allMembershipDocIds.add(doc.id);
        // Removed (tombstoned) memberships stay in the collection -- see the
        // trk-remove-item handler below -- so this must skip them, not just
        // check existence, or a removed tracker would keep showing up.
        if (!doc.data().removed) myTrackerMemberships[doc.data().trackerId] = doc.id;
      });
      membershipsLoaded = true;
      maybeRunMembershipBackfill();
      updateTrackerNavCount();
      if (document.getElementById('db-panel-trackers').classList.contains('active')) applyTrackerSearch();
      if (document.getElementById('db-panel-home').classList.contains('active')) renderHomeTab();
    });

    listenForTrackerGroups();
    listenForJoinedFlights();
  }

